import { render, staticRenderFns } from "./AdminCitiesAdd.vue?vue&type=template&id=18719362&"
import script from "./AdminCitiesAdd.vue?vue&type=script&lang=js&"
export * from "./AdminCitiesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports